import { render, staticRenderFns } from "./PccOrderCargoHandlingPropertiesEdit.vue?vue&type=template&id=f8710a76&scoped=true&"
import script from "./PccOrderCargoHandlingPropertiesEdit.vue?vue&type=script&lang=js&"
export * from "./PccOrderCargoHandlingPropertiesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8710a76",
  null
  
)

export default component.exports